import React from 'react';
import flatpickr from "flatpickr";
import 'flatpickr/dist/l10n/es';
import "flatpickr/dist/themes/material_red.css";
import Flatpickr from "react-flatpickr";
import { FormControl, Grid, InputLabel, IconButton, Box } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { gridSizeMdLg10 } from '@/shared/constants';
import { Spanish } from "flatpickr/dist/l10n/es.js";

interface DateRangePickerProps {
  onChange: (selectedDates: Date[]) => void;
  flatpickrRef: React.MutableRefObject<Flatpickr | null>
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  defaultValue?: Date[] | string[] | string
  label?: string
  onClear?: () => void;
  customStyle?: any
  custom_options?: Partial<flatpickr.Options.Options>
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  flatpickrRef,
  onChange,
  size = gridSizeMdLg10,
  defaultValue,
  label = '',
  onClear,
  customStyle = {
    font: 'inherit',
    fontSize: '14px'
  },
  custom_options

}) => {
  const handleClear = () => {
    if (flatpickrRef.current) {
      flatpickrRef.current.flatpickr.clear();
    }
    if (onClear) {
      onClear();
    }
  };

  return (
    <Grid item {...size}>
      <FormControl fullWidth>
        <InputLabel shrink htmlFor="fecha">
          {label}
        </InputLabel>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Flatpickr
            ref={flatpickrRef}
            placeholder='Rango de Fecha'
            //defaultValue={defaultValue?.toString()}
            value={defaultValue}
            options={{
              // Sin maxDate global: hay listados (p. ej. Activaciones → Instalaciones,
              // agendas) que filtran fechas futuras. Quien necesite limitar a hoy
              // lo pasa por custom_options={{ maxDate: new Date() }}.
              mode: 'range',
              dateFormat: 'Y-m-d',
              locale: {
                ...Spanish,
                rangeSeparator: " hasta ",
                firstDayOfWeek: 1,
                weekdays: {
                  shorthand: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
                  longhand: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                },
                months: {
                  shorthand: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                  longhand: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                },
              },
              // Permite al consumidor extender/sobrescribir las opciones
              // (ej. maxDate, minDate, enable). Va al final para que sus
              // claves tengan prioridad sobre las defaults de arriba.
              ...(custom_options ?? {}),
            }}

            onChange={(e) => onChange(e)}

            style={{
              width: '100%',
              padding: '0px 9px',
              height: '53.11px',
              border: '1px solid #ccc',
              borderRadius: '9px',
              font: 'inherit',
              fontSize: '14px',
              ...customStyle
            }}
          />
          {onClear && (
            <IconButton
              onClick={handleClear}
              size="small"
              sx={{
                minWidth: '40px',
                height: '40px',
                color: 'error.main',
                '&:hover': {
                  backgroundColor: 'error.light',
                  color: 'error.dark'
                }
              }}
              title="Limpiar fechas"
            >
              <ClearIcon />
            </IconButton>
          )}
        </Box>
      </FormControl>
    </Grid>
  );
};

export default DateRangePicker;
